import React from "react";

import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { GetApp } from "@mui/icons-material";
import Moment from "moment";

import { ButtonContactGreen } from "components/cardBodyStyle";

const ExcelReportClientsTransactions = ({ excelData, fileName, disabled }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const fileExtension = ".xlsx";
  let transformedData = [];

  const columnHeaders = {
    reference: "Referencia",
    client: "Cliente",
    document: "Documento",
    email: "Correo electronico",
    phone: "Telefono",
    percentage: "% comision",
    sub_Total: "SubTotal",
    iva_SubTotal: "Iva",
    total: "Total",
    percentageTotal: "Comision total",
    transferTotal: "Total a transferir",
    dateTransaction: "Fecha transaccion",
  };

  // CREAR LA LISTA CON EL MAPEADO
  if (excelData.length > 0) {
    transformedData = excelData.map((item) => {
      const commissionPercentage = parseFloat(item.client.percentage);
      const payTotal = parseFloat(item.total);

      // Cálculo de la comisión
      const percentageTotal =
        isNaN(commissionPercentage) || isNaN(payTotal)
          ? 0
          : (commissionPercentage * payTotal) / 100;

      const dateCreated =
        item.paymentTransactions.length > 0
          ? Moment(item.paymentTransactions[0].createdAt).format("YYYY-MM-DD")
          : "";

      // Creamos un objeto vacío para cada fila
      const row = {};

      // Ahora llenamos el resto de los campos en `row`
      row.reference = item.reference;
      row.client = item.client.companyName;
      row.document = item.client.documentId;
      row.email = item.client.email;
      row.phone = item.client.phone;
      row.percentage = parseFloat(item.client.percentage);
      row.sub_Total =
        item.description === "PAGO POR API"
          ? parseFloat(item.total)
          : parseFloat(item.subTotal);
      row.iva_SubTotal = parseFloat(item.ivaSubtotal);
      row.total = parseFloat(item.total);
      row.percentageTotal = percentageTotal;
      row.transferTotal = parseFloat(item.commissionPaymentTotal);
      row.dateTransaction = dateCreated;

      // Mapeamos los encabezados con los valores correspondientes
      const mappedRow = Object.keys(row).reduce((acc, key) => {
        acc[columnHeaders[key] || key] = row[key];
        return acc;
      }, {});

      return mappedRow;
    });
  }

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(transformedData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <>
      {/*<Tooltip title={fileName}>*/}
      <ButtonContactGreen
        onClick={(e) => exportToExcel(fileName)}
        // className={className}
        startIcon={<GetApp style={{ fontSize: 14 }} />}
        disabled={disabled}
        style={{
          fontSize: 12,
        }}
      >
        {" "}
        Excel
      </ButtonContactGreen>
      {/*</Tooltip>*/}
    </>
  );
};

export default ExcelReportClientsTransactions;
